/**
 * i18n minimal: dicționare per limbă, t(cheie). Momentan doar engleză.
 * Pentru a adăuga o limbă în viitor: adaugă un obiect nou în STRINGS (ex.
 * `ro: {…}`) și reintrodu selecția limbii în getLang() (localStorage /
 * navigator.language) plus un setLang() persistent și un comutator în UI.
 */

const STRINGS = {
  en: {
    logout: "Sign out",
    logoutAll: "Sign out of all devices",
    // nav
    "nav.dashboard": "Dashboard",
    "nav.plan": "Plan & billing",
    "nav.activity": "Activity",
    "nav.referral": "Refer & earn",
    "nav.codes": "Codes & referrals",
    "nav.section.workspace": "Workspace",
    "nav.section.admin": "Admin console",
    "nav.console": "Clients & usage",
    "nav.tickets": "Support tickets",
    "nav.section.content": "Content",
    "nav.news": "News",
    "nav.research": "Research",
    "nav.blog": "Blog",
    "nav.settings": "Settings",
    "nav.help": "Help & support",
    "nav.terms": "Terms",
    "nav.privacy": "Privacy",
    "nav.dpa": "DPA",
    "nav.cookies": "Cookies",
    "nav.contact": "Contact us",
    // help & support modal
    "help.title": "Help & support",
    "help.sub": "Questions about setup, billing or your assistant? We usually reply within one business day.",
    "help.contact": "Contact support",
    "help.or": "or email us directly",
    // feedback (doar planuri plătite)
    "nav.feedback": "Send feedback",
    "fb.title": "Send feedback",
    "fb.sub": "An idea, something confusing, something broken? Type it or dictate it - every message reaches us.",
    "fb.subTypeOnly": "An idea, something confusing, something broken? Every message reaches us.",
    "fb.placeholder": "What should we know?",
    "fb.listening": "Listening… start talking",
    "fb.dictate": "Dictate",
    "fb.stop": "Stop",
    "fb.lang": "Dictation language",
    "fb.listeningHint": "Your words appear above - edit them before sending.",
    "fb.voicePrivacy": "Dictation uses your browser's speech recognition (Google in Chrome, Apple in Safari). We only receive the text you send.",
    "fb.micBlocked": "Your browser isn't allowed to use the microphone. Allow it from the address bar and try again, or type instead.",
    "fb.micNetwork": "Dictation needs an internet connection, and some browsers (like Brave) don't offer it. You can type instead.",
    "fb.micMissing": "We couldn't find a microphone. You can type instead.",
    "fb.micFailed": "Dictation didn't work this time. You can type instead.",
    "fb.send": "Send",
    "fb.sending": "Sending…",
    "fb.thanks": "Thank you! We read every message.",
    "fb.dailyLimit": "You've sent a lot of feedback today - thank you! Please try again tomorrow.",
    "tk.source.feedback": "Feedback",
    "tk.fb.voice": "dictated",
    "tk.fb.text": "typed",
    // settings
    "set.title": "Settings",
    "set.sub": "Preferences for your console.",
    "set.theme.title": "Appearance",
    "set.theme.desc": "Choose a light or dark console, or follow your system setting.",
    "set.theme.light": "Light",
    "set.theme.dark": "Dark",
    "set.theme.auto": "Auto",
    "set.billing.title": "Billing details",
    "set.billing.desc": "The company details shown on your invoices. Your card and payment method are managed securely by Stripe.",
    "set.billing.save": "Save billing details",
    "set.billing.saved": "Billing details updated.",
    "set.billing.portal": "Manage payment method",
    "set.del.title": "Delete account",
    "set.del.desc": "This is how you close your account. Here is exactly what happens:",
    "set.del.p1": "Your sites stop working: the assistant disappears from your websites right away.",
    "set.del.p2": "Your subscription is cancelled and ends at the end of the period you already paid for. You are not charged again.",
    "set.del.p3": "If you sign in again within 90 days, everything is restored: your account, sites and history.",
    "set.del.p4": "After 90 days your account and its data are permanently deleted.",
    "set.del.open": "Delete my account…",
    "set.del.password": "Enter your current password to confirm",
    "set.del.confirm": "Delete my account",
    "set.del.wrongPassword": "That password is incorrect.",
    "set.del.noPassword": "Your account signs in with Google and has no password. To delete it, write to support@askmywebsiteai.com from the email address of your account.",
    "set.resetDay.title": "Monthly reset day",
    "set.resetDay.desc": "The day of the month your answer quota resets. In shorter months the reset falls on the last day of the month (e.g. day 31 → Feb 28). The new day applies at the end of the current billing cycle, not immediately.",
    "set.resetDay.auto": "Automatic (billing/registration date)",
    "set.resetDay.current": "Currently resets on {0}.",
    "set.resetDay.save": "Save reset day",
    "set.resetDay.saved": "Saved. The new reset day applies from {0}.",
    "set.install.title": "Install the app",
    "set.install.desc": "Add the console to your home screen - it opens full screen, with its own icon, like a native app.",
    "set.install.button": "Install app",
    "set.install.ios": "On iPhone or iPad, open this page in Safari, tap the Share button, then choose “Add to Home Screen”.",
    "set.install.other": "In Chrome or Edge, use the install icon in the address bar. On a phone, open the browser menu and choose “Add to Home Screen”.",
    "set.install.installed": "Installed - you are using the app right now.",
    "set.pw.title": "Password",
    "set.pw.desc": "Change the password you use to sign in. Other devices will be signed out.",
    "set.pw.current": "Current password",
    "set.pw.new": "New password",
    "set.pw.repeat": "Repeat new password",
    "set.pw.save": "Change password",
    "set.pw.saved": "Password changed. Other devices have been signed out.",
    "set.pw.mismatch": "The new passwords do not match.",
    "set.pw.tooShort": "New password must be at least 8 characters.",
    "set.pw.wrongCurrent": "Your current password is incorrect.",
    "set.pw.sameAsOld": "The new password must be different from the current one.",
    // auth
    "auth.h.register": "Create your account",
    "auth.h.login": "Welcome back",
    "auth.sub.registerBiz": "We're a B2B service, so we also need your billing details.",
    "auth.continue": "Continue",
    "auth.back": "Back",
    "auth.sub.login": "Sign in to your console.",
    "auth.register": "Sign up",
    "auth.login": "Sign in",
    "auth.orEmail": "or continue with email",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.password2": "Repeat password",
    "auth.refCodeApplied": "Code {0} applied - {1}% off your first payment.",
    "auth.refCodeBad": "Account created, but the referral code couldn't be applied. You can enter a code at checkout.",
    "auth.marketingConsent": "Send me occasional emails about offers and product news. Unsubscribe anytime.",
    "biz.companyName": "Company name",
    "biz.taxId": "Tax ID (VAT / NIF / CIF)",
    "biz.addressLine1": "Billing address",
    "biz.addressLine2": "Address line 2",
    "biz.optional": "optional",
    "biz.city": "City",
    "biz.postalCode": "Postal code",
    "biz.country": "Country",
    "biz.countrySelect": "Select a country…",
    "biz.gate.h": "Complete your business details",
    "biz.gate.sub": "AskMyWebsite AI is billed to a business. Add your company details to continue.",
    "biz.gate.submit": "Save and continue",
    "biz.gate.logout": "Sign out",
    "auth.submitRegister": "Create account",
    "auth.submitLogin": "Sign in",
    "auth.mismatch": "Passwords do not match.",
    "auth.emailTaken": "This email is already registered.",
    "auth.f1": "Answers questions, shows where to click",
    // „One clear price per month" a ieșit odată cu prețurile publice (7 aug 2026):
    // ecranul de login e ultima suprafață publică unde mai apărea o promisiune
    // comercială, iar landing-ul nu mai face niciuna.
    "auth.f2": "Answers only from your own content",
    "auth.f3": "See answers left, not confusing tokens",
    "auth.h.forgot": "Reset your password",
    "auth.sub.forgot": "We'll email you a link to set a new password.",
    "auth.submitForgot": "Send reset link",
    "auth.forgotLink": "Forgot password?",
    "auth.backToLogin": "Back to sign in",
    "auth.forgotSent": "If that email is registered, a reset link is on its way.",
    "auth.registerVerify": "Account created. Check your email for a verification link, then sign in.",
    "auth.verifyFirst": "Please verify your email first - we've sent you a new verification link.",
    // The server reported that the verification email could not be sent (emailSent: false):
    // say so instead of promising an email that does not exist.
    "auth.registerNoEmail": "Account created, but we couldn't send the verification email right now. Try “Resend” in a minute, or write to support@askmywebsiteai.com.",
    "auth.verifyFirstNoEmail": "Please verify your email first. We couldn't send the verification email right now - try “Resend” in a minute, or write to support@askmywebsiteai.com.",
    // A3 / A4: why the user lands on the sign-up tab
    "auth.fromDemo": "Create a free account to open the live demo - no card needed.",
    "auth.h.reset": "Set a new password",
    "auth.submitReset": "Set new password",
    "auth.resetDone": "Password updated - you can sign in now.",
    "auth.resetInvalid": "This reset link is invalid or has expired.",
    "verify.banner": "Please verify your email address to secure your account.",
    "verify.resend": "Resend verification email",
    "verify.resendIn": "You can resend in {0}",
    "verify.resendErr": "Couldn't send just now - please try again in a moment.",
    "verify.notSent": "We couldn't send the verification email right now. Try “Resend” in a minute, or write to support@askmywebsiteai.com.",
    "auth.deleted": "Your account was deleted. Sign in within 90 days to restore it.",
    "verify.sent": "Verification email sent - check your inbox.",
    "verify.linkOk": "Email verified - you can sign in now.",
    "verify.linkBad": "That verification link is invalid or has expired.",
    // banner „fără abonament activ" - un cont care n-a cumpărat încă (plan free)
    // sau pus manual pe un plan neactivat. Textul spune ce se întâmplă când se
    // termină răspunsurile, nu doar că lipsește abonamentul.
    "noSub.banner": "No active subscription - {0} of {1} answers left. When they run out, your assistant stops replying to visitors.",
    "noSub.bonus": "You also have {0} bonus answers that keep serving after the monthly ones run out.",
    "noSub.cta": "See plans",
    // banner „cotă epuizată" - apare când widgetul chiar s-a stins pentru
    // vizitatori noi (backend: answersExhausted). Spune ce se întâmplă pe
    // site-urile clientului, nu doar un număr, și ce îl repară.
    "quota.exhausted.banner":
      "You've used all {0} answers included this month - your assistant is no longer answering new visitors on any of your sites. Visitors already mid-conversation get a small allowance to finish.",
    "quota.exhausted.cta": "Upgrade or add answers",
    // avertizare mai blândă la 80% - nu s-a stins nimic încă, doar un semnal din timp.
    "quota.warning.banner": "You've used {0} of {1} answers this month ({2}%). Upgrade or add answers before you run out to avoid interrupting your assistant for visitors.",
    "quota.warning.cta": "See plans",
    // overview
    "ov.hi": "Welcome back",
    "ov.sub": "Your assistant at a glance.",
    "ov.answersLeft": "Answers left",
    "ov.bonusInline": "[+{0} bonus]",
    "ov.of": "of {0}",
    "ov.renewsOn": "Resets on {0}.",
    "ov.plan": "plan",
    "ov.sitesUsed": "Sites",
    "ov.sitesUsedD": "{0} of {1} used",
    "ov.answersUsed": "Answers used",
    "ov.yourPlan": "Your plan",
    "ov.manageSites": "Manage sites",
    "ov.seePlans": "See plans",
    "ov.quickTitle": "Get started",
    "ov.quickSub": "Two steps to a live assistant on your site.",
    "ov.step1": "Create a site and copy the snippet",
    "ov.step2": "Open Agent and teach the AI your pages",
    "ov.upsellTitle": "Unlock more with Growth",
    // Conversațiile nu mai sunt momeala de upsell (sunt pe orice plan) - cârligul
    // e interpretarea: insights de ghidare + raportul AI săptămânal.
    "ov.upsellBody": "AI insights and a weekly report on what visitors ask, custom branding - your name, logo and colors - plus 2,500 answers a month.",
    // „Latest AI reports" - headline-ul ultimului raport per sit, link spre Insights.
    // A înlocuit teaserul „Coming soon" al unui raport global inexistent (2 aug 2026).
    "ov.reports.title": "Latest AI reports",
    "ov.reports.empty": "Weekly AI reports for each site will appear here. The first one runs automatically on Monday.",
    "ov.reports.locked": "Every Monday, AI reads your visitors' questions and writes a short report per site - what they looked for, where they got stuck, what to fix.",
    // plan
    // Blocul `plan.*` de mai jos aparținea în mare parte tabului „Plan & billing",
    // eliminat pe 7 aug 2026 odată cu cumpărarea self-serve (BILLING_SELF_SERVE).
    // Cheile rămân PĂSTRATE INTENȚIONAT, nu uitate: componenta se restaurează din
    // git când se redeschide cumpărarea, iar textele ei ar trebui altfel rescrise
    // de la zero. Excepțiile încă vii: `plan.betaCta` (eticheta CTA-urilor de
    // upgrade în beta), `plan.marketingTitle`/`plan.marketingConsent`,
    // `plan.apiKey*` (mutate în Settings) și `insights.lockedCta` & co, folosite
    // ca etichetă „normală" de `upgradeLabel`.
    "plan.title": "Plan & billing",
    "plan.sub": "One simple price. Pay for answers, not tokens.",
    "plan.current": "Current plan",
    "plan.answersMonth": "answers / month",
    "plan.sites": "sites",
    "plan.perMonth": "/ mo",
    "plan.choose": "Choose {0}",
    "plan.currentBtn": "Current plan",
    "plan.subscribe": "Subscribe to {0}",
    "plan.upgradeTitle": "Upgrade to {0}?",
    "plan.upgradeConfirm": "You'll be charged the prorated difference for the rest of the current period, and your billing date stays the same. The higher limits apply immediately.",
    "plan.upgradeBtn": "Upgrade to {0}",
    "plan.downgradeTitle": "Switch to {0}?",
    "plan.downgradeConfirm": "You keep your current plan and its limits until the end of the current period. {0} starts on your next billing date.",
    "plan.downgradeWarn": "No refunds for the current period.",
    "plan.downgradeBtn": "Schedule the switch",
    "plan.upgraded": "You're on {0} now. The prorated difference was charged to your card.",
    // Data explicită, nu „at the end of the current period": programarea trăiește
    // la Stripe (subscription schedule), iar clientul n-are cum să știe asta -
    // o dată concretă e singurul lucru care arată că cererea chiar s-a înregistrat.
    "plan.downgradeScheduled": "Done - you switch to {0} on {1}. Until then you keep your current plan and its limits.",
    "plan.downgradeScheduledSoon": "Done - you switch to {0} at the end of the current period. Until then you keep your current plan and its limits.",
    "plan.pendingBadge": "From {0}",
    "plan.cancelDowngrade": "Keep current plan",
    "plan.downgradeCancelled": "Scheduled downgrade cancelled - you stay on your current plan.",
    "plan.manageBilling": "Manage billing",
    "plan.renewsOn": "Renews on {0}.",
    // Subscription cancelled (Stripe portal or account deletion) but still paid up to the period end.
    "plan.endsOn": "Ends on {0}.",
    "plan.endingBanner": "Your subscription is cancelled and ends on {0}. Until then everything keeps working. Resume it to keep your plan.",
    "plan.resume": "Resume subscription",
    "plan.resumed": "Done - your subscription will renew as usual.",
    "plan.resumeWait": "Resuming your subscription…",
    "plan.confirming": "Confirming your payment…",
    "plan.applyingUpgrade": "Applying your upgrade to {0}…",
    "plan.checkoutSuccess": "Payment confirmed - welcome aboard!",
    "plan.checkoutCancelled": "Checkout cancelled - no charge was made.",
    "plan.confirmTimeout": "Payment is taking longer than expected to confirm. Refresh in a moment - if this persists, contact support.",
    "plan.customPrice": "Custom",
    "plan.contactUs": "Contact us",
    "plan.popular": "Most popular",
    "plan.metaCustom": "Limits tailored to your needs",
    "plan.siteOne": "site",
    "plan.renews": "Answers reset on {0}.",
    // Eticheta oricărui CTA de upgrade cât timp cumpărarea e închisă
    // (BILLING_SELF_SERVE): toate duc la pagina de contact, nu la un tab de
    // planuri, fiindcă tabul acela nu mai există. Vezi `upgradeLabel` din main.tsx.
    "plan.betaCta": "Contact us",
    "plan.overageTitle": "Overage balance",
    "plan.overageSub": "Extra answers beyond your plan draw from this balance (€15 / 500 answers). Optional.",
    "plan.addCredit": "Add balance",
    "plan.min": "Minimum €5.",
    "plan.added": "Added €{0} to your balance.",
    "plan.minNote": "min €5 · card payments coming soon",
    "plan.discountBanner": "Code {0} applied - {1}% off your first payment.",
    // founding offer
    "plan.foundingBadge": "Founding −{0}%",
    "plan.foundingBadgeGone": "Almost gone",
    "plan.foundingNote": "first {0} months, then €{1}",
    // varianta singular: un pendingDiscount de referral are months=1 și ar
    // produce altfel „first 1 months" (vezi resolveFoundingDiscount, api.ts)
    "plan.foundingNote1": "first month, then €{0}",
    "plan.foundingClaimed": "✓ Founding offer fully claimed - all founding spots are gone.",
    // referral
    "ref.title": "Refer & earn",
    "ref.sub": "Share your link. They save on their first month, you earn a commission.",
    "ref.yourCode": "Your code",
    "ref.yourLink": "Your link",
    "ref.copy": "Copy",
    "ref.copied": "Copied",
    // alegerea codului
    "ref.pickTitle": "Choose your code",
    "ref.pickSub": "Pick something short and memorable - it's what people will type and remember. Letters, numbers and dashes.",
    // fără „e.g.": inputul e text-transform: uppercase, deci placeholderul s-ar
    // vedea ca „E.G. RADU20"
    "ref.pickPlaceholder": "RADU20",
    "ref.pickBtn": "Claim this code",
    "ref.pickHint": "4–24 characters · A–Z, 0–9 and –",
    "ref.claimed": "Your code is {0}. It's yours - share it.",
    "ref.change": "Change code",
    "ref.changeCancel": "Keep {0}",
    "ref.changeBtn": "Switch to this code",
    "ref.changed": "Your code is now {0}. Links with {1} no longer work, but nobody else can take it.",
    "ref.changeWarn": "Anything you already printed or posted with your current code will stop working. Your old code stays reserved for you - nobody else can claim it, and you can switch back anytime.",
    "ref.err.code_taken": "That code is already taken. Try another one.",
    "ref.err.code_reserved": "That code is reserved. Try another one.",
    "ref.err.invalid_format": "Use 4–24 characters: letters, numbers and dashes only.",
    "ref.err.same_code": "That's already your code.",
    "ref.how": "How it works",
    "ref.how1": "Share your link or code with anyone who needs an assistant on their site.",
    "ref.how2": "They get {0}% off their first payment when they sign up with it.",
    "ref.how3": "You earn {0}% of what they actually pay - once, on their first payment.",
    "ref.how4": "Your earnings are held for {0} days (their refund window), then become available.",
    "ref.signups": "Signed up",
    "ref.converted": "Paid",
    "ref.pending": "On hold",
    "ref.available": "Available",
    "ref.pendingHint": "Waiting out the {0}-day refund window.",
    "ref.availableHint": "Ready to be paid out.",
    "ref.payoutNote": "Payouts are handled manually for now - contact us when you'd like to cash out.",
    "ref.earningsTitle": "Your commissions",
    "ref.earningsEmpty": "No commissions yet. Nothing is earned until someone you referred makes their first payment.",
    "ref.col.date": "Date",
    "ref.col.amount": "Amount",
    "ref.col.status": "Status",
    "ref.status.pending": "On hold until {0}",
    "ref.status.available": "Available",
    "ref.status.cancelled": "Cancelled",
    // sites
    "sites.title": "Dashboard",
    "sites.sub": "Each site gets its own AI assistant.",
    "sites.new": "New site",
    "sites.buyExtra": "Buy extra site",
    "sites.emptyH": "No sites yet",
    "sites.emptyP": "Create your first site to install the assistant.",
    "sites.create": "Create site",
    "sites.name": "Site name",
    "sites.namePh": "E.g. My customer portal",
    "sites.origins": "Domains it runs on",
    "sites.originsPh": "https://app.example.com",
    "sites.originsHint": "One per line, including https://",
    "sites.untitled": "Untitled site",
    "sites.wwwToggle": "Also allow the www. variant",
    "sites.wwwToggleHint": "{0} and {1} are different origins to a browser. Keeping both on one site means one widget either way.",
    "sites.originTaken": "{0} is already set up on your site “{1}”. A domain belongs to a single site - two would put two widgets on the same page. Edit that site instead.",
    "sites.devOrigin": "Use your public website address, like https://example.com - local and IP addresses can't be used.",
    "sites.siteLimit": "You've reached the number of sites your plan includes. Upgrade your plan or write to us to add more.",
    "sites.originInvalid": "One of those domains doesn't look right. Use just the domain, e.g. example.com or app.example.com - one per line.",
    "sites.answers": "answers",
    "sites.extraInline": "+{0} extra",
    "sites.limitReachedH": "You’ve reached your plan’s site limit",
    "sites.limitReachedP": "The {0} plan includes {1} site(s). Upgrade to add more.",
    "sites.upgrade": "Upgrade plan",
    "sites.createFirst": "Create site",
    "sites.col.name": "Site",
    "sites.col.status": "Status",
    "sites.col.trend": "Trend",
    "sites.col.conversations": "Conversations",
    "sites.col.last7d": "last 7 days",
    "sites.col.answers": "Answers",
    "sites.col.config": "Agent",
    "sites.col.visit": "Live site",
    "sites.open": "Open website",
    "sites.liveConfirmTitle": "Take this site live?",
    "sites.liveConfirmBody": "Visitors on {0} will start seeing the assistant right away.",
    "sites.offlineConfirmTitle": "Take this site offline?",
    "sites.offlineConfirmBody": "The assistant will stop showing to visitors on {0}.",
    "sites.thisMonth": "this month",
    "sites.tMonth": "this month",
    "sites.tTotal": "total",
    "sites.convLinkTitle": "Open the site's conversations",
    "sites.col.actions": "Actions",
    "sites.answersUsedTile": "Answers used",
    "sites.unassigned": "Unassigned",
    "sites.clientSites": "{0} sites",
    "sites.clientSite": "1 site",
    "sites.clientAnswers": "{0} answers this month",
    "sites.limitTitle": "Site limit reached",
    "sites.limitBody1": "Your {0} plan includes 1 site. Upgrade your plan to add more.",
    "sites.limitBodyN": "Your {0} plan includes {1} sites. Upgrade your plan to add more.",
    // charts
    "chart.title": "Response volume",
    "chart.sub": "Last 30 days",
    "chart.empty": "No responses in this period yet.",
    "chart.responses": "responses",
    "chart.conversations": "conversations",
    "chart.day": "on",
    // assistant funnel (Insights tab + account overview). impressions/opens/asked
    // are THREE numbers on three different units (page views vs. distinct sessions),
    // never summed or compared - see FunnelTotals in api.ts. Copy must not imply a
    // "visitor" count for impressions: it's a per-page-view, undeduplicated tally.
    "funnel.empty":
      "No data yet. These signals are new - they start arriving once visitors reach your site with the current version of the widget installed, so earlier traffic can’t appear here.",
    "funnel.impressionsUnit": "page views",
    "funnel.opens": "Opened the assistant",
    "funnel.opensNote": "{0}% of page views where it was shown.",
    "funnel.asked": "Asked a question",
    "funnel.askedNote": "{0}% of those asked something.",
    // Fereastra de tranziție: SDK vechi din cache trimit întrebări fără evenimente
    // de sesiune, deci "asked" poate depăși "opens". Nu ascundem cifrele.
    "funnel.mixedVersions": "Some questions come from an older widget version that didn't report opens, so early numbers can look uneven.",
    "funnel.guidanceScale": "Counted per guidance episode, not per visitor - one visit can be guided more than once.",
    "funnel.trend": "Page views per day",
    // conversations
    "conv.title": "Visitor conversations",
    "conv.sub": "Every question asked, grouped by visit.",
    "conv.empty": "No conversations yet. They’ll appear here as visitors use the assistant on your site.",
    "conv.count": "{0} visits",
    "conv.countOne": "1 visit",
    "conv.session": "Session {0}",
    "conv.noQuestion": "(no question recorded)",
    "conv.msgsOne": "1 message",
    "conv.msgs": "{0} messages",
    // drumul de dinaintea unei întrebări (recentActions) - etichetă scurtă
    "conv.trail": "Before asking:",
    // banda de sumar din capul tabului Conversations (ConversationsSummary)
    "conv.sum.month": "Questions this month",
    "conv.sum.monthVal": "{0} questions",
    "conv.sum.monthValOne": "1 question",
    "conv.sum.avg": "Avg. per visit",
    "conv.sum.avgVal": "{0} questions",
    "conv.sum.pages": "Most active pages",
    "conv.sum.pagesEmpty": "No pages yet.",
    "conv.filterFrom": "From",
    "conv.filterTo": "To",
    "conv.filterClear": "Clear",
    // filtru de canal (text/voce) - lângă filtrele de dată
    "conv.channel.all": "All channels",
    "conv.channel.text": "Text",
    "conv.channel.voice": "Voice",
    // badge pe rândul sesiunii + marcaj pe tura de voce în firul desfășurat
    "conv.voice": "Voice",
    // chips cu acțiunile agentului, sub perechea Q/A a unui mesaj
    "conv.actions.label": "Agent actions:",
    "conv.act.addToCart": "Added to cart: {0}",
    "conv.act.addToCartQty": "Added to cart: {0} ×{1}",
    "conv.act.removedFromCart": "Removed from cart: {0}",
    "conv.act.setQuantity": "Set quantity: {0} ×{1}",
    "conv.act.openCheckout": "Opened checkout",
    "conv.act.searched": "Searched: “{0}”",
    "conv.act.searchedRange": "Searched: “{0}” ({1})",
    "conv.act.range.both": "{0} - {1}",
    "conv.act.range.min": "from {0}",
    "conv.act.range.max": "up to {0}",
    "conv.act.navigate": "Went to {0}",
    "conv.act.showedProducts": "Showed products: {0}",
    "conv.act.compared": "Compared: {0}",
    "conv.act.askedClarification": "Asked for clarification",
    "conv.act.taskCompleted": "Task completed",
    "conv.act.guided": "Guided on page",
    "pager.label": "Pagination",
    "pager.prev": "Previous page",
    "pager.next": "Next page",
    // tabul „Insights" al unui site - interpretarea (raport, insights, arhivă)
    "progress.current.sub": "What visitors asked, read for you.",
    "progress.period": "Covers {0} – {1}",
    "progress.latest": "Latest",
    "progress.archive.title": "Report archive",
    "progress.archive.sub": "Every weekly report generated for this site. Open one to read it in full.",
    "progress.archive.empty": "No reports yet. The first one runs automatically every Monday.",
    "progress.archive.onlyOne": "This is your only report so far - a new one is generated every Monday.",
    // tabul „Insights" - fraza-erou de sus (etajul 1), din funnel.totals
    "insights.hero": "In the last 30 days your assistant was seen on {0} page views, opened {1} times, and answered {2} questions.",
    "insights.heroGuided": "It offered guidance {0} times, and {1} of those journeys reached their goal.",
    "insights.heroClaims": "Before stating a price or saying something is not in stock, it checked {0} such facts against your catalogue and corrected itself {1} times.",
    // etajul 2 - cele trei întrebări
    "insights.q1.title": "Is the assistant being used?",
    "insights.q1.sub": "From a page view to a visitor actually asking something.",
    "insights.q2.title": "Does the assistant actually help?",
    "insights.q2.sub": "From a question asked to the visitor reaching what they needed.",
    "insights.q3.title": "What should you fix on your site?",
    "insights.q3.sub": "The pages and the questions your site doesn't answer well yet.",
    // etajul 3 - detaliile de volum, colapsate implicit
    // tabul „Dashboard" al unui sit (SiteOverviewTab) - pulsul de volum pe 30 de zile
    "so.pageViews": "Page views",
    "so.opened": "Opened the assistant",
    "so.asked": "Asked a question",
    "so.last30": "Last 30 days",
    // tooltipuri educative (InfoTip) - o singură propoziție fiecare
    "insights.tip.opens": "The visitor clicked the assistant open on a page where it was shown.",
    "insights.tip.asked": "The visitor typed an actual question, not just opened the chat.",
    "insights.tip.guided": "The assistant walked the visitor through the site step by step.",
    "insights.tip.reached": "The visitor got to the exact page or element they were looking for.",
    "insights.tip.abandoned": "The visitor closed the guidance before the end.",
    "insights.tip.targetMissing": "The assistant wanted to point at something that no longer exists on the page.",
    "insights.tip.questions": "How many questions visitors asked while on this page.",
    "insights.tip.fallbacks": "The assistant had to ask the visitor to clarify what they meant.",
    // guidance insights (carduri din tabul Insights)
    "insights.aiTitle": "AI weekly report",
    "insights.runNow": "Run now",
    "insights.running": "Running…",
    "insights.notEnough": "Not enough data yet - check back after more visitors use the assistant.",
    "insights.generated": "Generated {0}",
    "insights.summaryEmpty": "Your first weekly report will appear here. It runs automatically every Monday.",
    "insights.locked": "Guidance insights are a Growth+ feature.",
    "insights.lockedCta": "Upgrade to Growth",
    // fricțiune per pagină
    "insights.friction.title": "Where visitors get stuck",
    "insights.friction.sub": "The pages with the most questions, clarifications and drop-off.",
    "insights.friction.empty": "No page activity in this period yet. It builds up as visitors use the assistant.",
    "insights.friction.viewConv": "See the conversations that happened on {0}",
    "insights.m.questions": "Questions",
    "insights.m.fallbacks": "Clarifications",
    "insights.m.abandoned": "Abandoned",
    "insights.m.targetMissing": "Missing target",
    // funnel de ghidare (titlul/subtitlul vin din insights.q2.*)
    "insights.funnel.empty": "No guidance activity in this period yet.",
    "insights.funnel.asked": "Asked",
    "insights.funnel.guided": "Guided",
    "insights.funnel.reached": "Reached",
    "insights.funnel.abandoned": "Abandoned",
    "insights.funnel.targetMissing": "Missing target",
    "insights.funnel.ofAsked": "{0}% of asked",
    // nevoi neacoperite (din rezumatul AI)
    "insights.unmet.title": "What visitors can't find",
    "insights.unmet.sub": "Recurring themes your site doesn't answer well yet.",
    "insights.unmet.empty": "Your first weekly report will surface unmet needs here. It runs automatically every Monday.",
    "insights.unmet.approx": "~{0} questions",
    // raportul complet (modal)
    "insights.report.friction": "Friction points",
    "insights.report.unmet": "Unmet needs",
    "insights.report.recommendations": "Recommendations",
    // activity (audit log) - vedere INTERNĂ, doar super-admin: clientul nu o vede
    "act.title": "Audit log",
    "act.sub": "Who did what, on which account, and when. Internal - use it to answer a support ticket.",
    "act.empty": "No events match these filters.",
    "act.filterAccount": "Account",
    "act.filterAccountPlaceholder": "email…",
    "act.filterByThis": "Filter by this account",
    "act.filterAction": "Event",
    "act.filterAll": "All events",
    "act.filterFrom": "From",
    "act.filterTo": "To",
    "act.filterClear": "Clear",
    "act.more": "Load older",
    "act.byClient": "by the client",
    // acțiunile noastre se marchează explicit: la un ticket, prima întrebare e
    // „a schimbat clientul ceva, sau am schimbat noi?"
    "act.byUs": "by us",
    "act.bySystem": "by the system",
    "act.byAnon": "signed out",
    "act.byUnknown": "actor not recorded",
    "act.ip": "from {0}",
    // descrieri per acțiune - meta se randează prin ele, nu ca JSON brut
    "act.a.auth.register": "Account created",
    "act.a.auth.login": "Signed in",
    "act.a.auth.login_failed": "Failed sign-in attempt",
    "act.a.auth.password_reset_requested": "Password reset requested",
    "act.a.auth.password_reset_completed": "Password changed",
    "act.a.auth.email_verified": "Email verified",
    "act.a.auth.admin_promoted": "Granted admin access",
    "act.a.app.create": "Site created",
    "act.a.app.update": "Site settings changed",
    "act.a.app.branding_update": "Widget branding changed",
    "act.a.app.delete": "Site deleted",
    "act.a.config.publish": "Configuration published",
    "act.a.config.rollback": "Configuration rolled back",
    "act.a.builder.session_started": "Editor opened",
    "act.a.account.delete": "Account deleted",
    "act.a.account.reactivate": "Account reactivated",
    "act.a.account.purge": "Account permanently deleted",
    "act.a.plan.change": "Plan changed",
    "act.a.billing.mark_paid": "Payment recorded",
    "act.a.credit.add": "Credit added",
    "act.a.addons.grant": "Add-ons granted",
    // branding editor
    "brand.title": "Widget branding",
    "brand.sub": "Make the assistant yours - name, logo, color, welcome message and tone. Logo and brand color are picked up automatically from your site during Neural Scan; anything you set here yourself is never overwritten.",
    "brand.name": "Assistant name",
    "brand.namePh": "AI Concierge",
    "brand.logo": "Chat button icon",
    "brand.iconPresets": "Ready-made icons",
    "brand.iconDefault": "Default - the AskMyWebsite mark",
    "brand.icon.chat": "Chat bubble",
    "brand.icon.chat-dots": "Chat bubble with dots",
    "brand.icon.question": "Question mark",
    "brand.icon.headset": "Support headset",
    "brand.icon.bot": "Robot",
    "brand.icon.sparkles": "AI sparkles",
    "brand.logoPh": "…or paste your own image URL / upload →",
    "brand.logoUpload": "Upload image",
    "brand.logoUploading": "Uploading…",
    "brand.logoBadType": "Please choose an image file.",
    "brand.logoHint": "Your image is shown inside the round chat button. Square images look best.",
    "brand.iconHint": "Pick a ready-made icon, or use your own image below.",
    "brand.bubblePreviewTitle": "How the chat-opening button will look",
    "brand.color": "Primary color",
    "brand.textColor": "Text color",
    "brand.textColorHint": "Text and icons shown on the primary color (header, the ✕ button, your message bubbles). Defaults to automatic contrast - pick a color to override it.",
    "brand.logoOnly": "Just logo",
    "brand.logoOnlyHint": "Upload an image first - the button then shows only your logo, without the colored circle.",
    "brand.customCssLauncher": "Button custom CSS",
    "brand.customCssLauncherPh": ".aig-toggle { /* the round button */ }",
    "brand.customCssChat": "Chat custom CSS",
    "brand.customCssChatPh": ".aig-panel { /* the open chat window */ }",
    "brand.customCssLocked": "Custom CSS is available on white-label plans (Agency and up).",
    "brand.customCssLockedCta": "See plans",
    "brand.previewTitle": "Preview",
    "brand.previewAsk": "Ask something…",
    "brand.previewSend": "Send",
    "brand.previewUserMsg": "Do you ship to Spain?",
    "brand.welcome": "Welcome message",
    "brand.welcomePh": "Hi! I can see what you're doing - tell me what you're looking for and I'll guide you.",
    "brand.fallback": "When there's no good answer",
    "brand.fallbackPh": "I did not fully understand your request. Please rephrase it.",
    "brand.fallbackHint": "Shown when the assistant can't answer at all - point visitors to your contact channel if you have one.",
    "brand.tone": "Tone",
    "brand.toneDefault": "Default (neutral)",
    "brand.toneFriendly": "Friendly",
    "brand.toneProfessional": "Professional",
    "brand.tonePlayful": "Playful",
    "brand.toneConcise": "Concise",
    "brand.save": "Save branding",
    "brand.saved": "Saved ✓",
    "brand.poweredByNote": "The “Powered by AskMyWebsite[AI]” line is removed on Growth and up.",
    "brand.poweredByNoteCta": "See plans",
    "brand.resetAll": "Reset to default",
    "brand.resetTitle": "Reset branding to default?",
    "brand.resetBody": "This clears the assistant's name, logo, color, welcome message and tone - visitors will see the default Ask My Website AI look. This can't be undone.",
    "brand.resetConfirm": "Reset to default",
    "brand.assistantExperience": "Assistant experience",
    "brand.orbChat": "Enable orb assistant",
    "brand.orbChatHint": "The orb assistant replaces the classic chat panel with a glowing orb and a dark HUD card, and includes voice mode. Off = classic chat panel.",
    "brand.voice": "Voice",
    "brand.voiceStandard": "Standard",
    "brand.voiceSerious": "Serious",
    "brand.voiceStoryteller": "Storyteller",
    "brand.voiceHint": "Applies to the orb assistant's voice mode.",
    // agent notes (notițe libere pentru agent - pe orice plan, fără gating)
    "notes.title": "Agent notes",
    "notes.sub": "Standing instructions for the assistant - it follows these when answering visitors on this site.",
    "notes.placeholder": "e.g. Never promise delivery in under 3 days. Send warranty questions to our contact form.",
    "notes.hint": "Guidance only - these can't make the assistant click, submit or act on the page, or answer outside this site.",
    "notes.count": "{0}/{1}",
    "notes.save": "Save notes",
    "notes.saved": "Saved ✓",
    // voice minutes per visitor (F-06)
    "vmin.title": "Voice minutes per visitor",
    "vmin.sub": "How many minutes of voice conversation each visitor gets on this site. When they run out, the assistant says so out loud and the conversation continues in the chat, with the full transcript kept.",
    "vmin.hint": "Default: 3 minutes. Allowed: 1-60.",
    "vmin.save": "Save limit",
    "vmin.saved": "Saved ✓",
    "vmin.invalid": "Enter a whole number between 1 and 60, or leave empty for the default.",
    // site detail extra
    "sd.domains": "Domain",
    "sd.domainsNote": "The install snippet is tied to these domains. To use a different domain, delete this site and create a new one.",
    "sd.demoFlag": "This is a demo site (internal)",
    "sd.voiceFlag": "Voice conversations enabled on this site",
    "sd.voiceFlagHint": "Admin only. When on, visitors get the microphone button and can talk to the assistant (needs the voice provider keys on this environment). When off, the button never appears and voice sessions are refused.",
    "sd.demoFlagHint": "Admin only. When on, this site's widget answers through the signed-in demo flow instead of the public one - visitors must be logged in, and their usage counts against the demo allowance.",
    "sd.clientLabel": "Client",
    "sd.clientLabelPh": "e.g. Acme Corp",
    // buy answers
    "plan.buyExtra": "Buy extra",
    "plan.buyExtraTitle": "Buy extra",
    "plan.buyTitle": "Buy extra answers",
    "plan.buySub": "For usage beyond your monthly plan - €{0} per {1} answers.",
    "plan.buyBtn": "Buy for €{0}",
    "plan.buyQty": "How many",
    "plan.extraAvailable": "≈ {0} extra answers available",
    "plan.bought": "Added {0} extra answers.",
    "plan.buyNeedsPlan": "Extra answers are available once you're on a paid plan.",
    "plan.b2bNote": "AskMyWebsite[AI] is built for businesses and professionals.",
    "plan.billingTitle": "Billing details",
    "plan.billingNote": "We use your billing country to apply the correct tax on your invoice. Your company name, address and tax ID are already filled in from sign-up.",
    "plan.billingCountry": "Billing country",
    "plan.billingPostal": "Postal code",
    "plan.billingCancel": "Cancel",
    "plan.billingContinue": "Continue to payment",
    "plan.promoLabel": "Promo or referral code",
    "plan.promoOptional": "optional",
    "plan.promoApply": "Apply",
    "plan.promoApplied.percent": "Code applied - {0}% off your first payment.",
    "plan.promoApplied.trial": "Code applied - {0}-day free trial. Your card won't be charged until the trial ends.",
    "plan.promoApplied.credit": "Code applied - €{0} credit on your account.",
    "plan.promoErr.invalid_code": "That code isn't valid.",
    "plan.promoErr.code_exhausted": "This code has been fully used up.",
    "plan.promoErr.own_code": "You can't redeem your own referral code.",
    "plan.promoErr.already_redeemed": "Your account already has a code applied.",
    "plan.promoErr.already_paid": "Codes can only be applied before your first payment.",
    "plan.promoErr.generic": "Couldn't apply the code. Please try again.",
    "plan.topupSuccess": "Payment received - your extra answers will appear in a moment.",
    "plan.topupCancelled": "Top-up cancelled - no charge was made.",
    "plan.slotsTitle": "Extra sites",
    "plan.slotsSub": "Add site slots beyond your plan - €{0} / month each.",
    "plan.slotsAddTitle": "Add {0} site slot(s)?",
    "plan.slotsAddConfirm": "The prorated difference for the current period is charged now, and your billing date stays the same.",
    "plan.slotsAddBtn": "Add slots",
    "plan.slotsRemoveTitle": "Remove {0} site slot(s)?",
    "plan.slotsRemoveConfirm": "The change applies now and the unused amount is credited towards your next invoice.",
    "plan.slotsRemoveBtn": "Remove slots",
    "plan.slotsApply": "Apply",
    "plan.slotsUpdated": "Slots updated - your subscription will reflect it in a moment.",
    "plan.slotsNote": "Slots used by existing sites can't be removed - delete the site first.",
    "plan.marketingTitle": "Email preferences",
    "plan.marketingConsent": "Send me occasional emails about offers and product news. Unsubscribe anytime.",
    "plan.marketingSaved": "Saved ✓",
    "plan.apiKeyTitle": "API key",
    "plan.apiKeySub": "Programmatic access to your account (available on your plan). Rotating replaces any previously issued key.",
    "plan.apiKeyBtn": "Rotate API key",
    "plan.apiKeyWarning": "Copy it now - this key won't be shown again.",
    // site detail
    // „Dashboard" pentru om, „overview" în rută - ruta contului ocupă deja #/dashboard
    "sd.tab.overview": "Dashboard",
    "sd.tab.insights": "Insights",
    "sd.tab.conversations": "Conversations",
    "sd.tab.widget": "Widget",
    "sd.tab.settings": "Settings",
    "sd.live": "Live",
    "sd.notLive": "Not live",
    "sd.goLive": "Go live",
    "sd.takeOffline": "Take offline",
    "sd.openBuilder": "Open Agent",
    "sd.install": "Install",
    "sd.installSub": "Add the snippet below to your site and the assistant goes live. Steps for your platform:",
    "sd.installBrandHint": "Once the snippet is live, run Neural Scan from your site - we'll pick up your logo and brand colors automatically and dress the chat in them, so it matches your site from the very first visitor.",
    // Selectorul de platformă din cardul Install: detectăm platforma sitului
    // server-side (services/platformDetect.ts) și preselectăm varianta; clientul
    // poate alege alta oricând - alegerea se salvează în DB (orice dispozitiv).
    "sd.platform.label": "How is your site built?",
    "sd.platform.detected": "detected",
    "sd.platform.gtmHint": "We noticed your site uses Google Tag Manager - if editing your site's code is inconvenient, pick the Google Tag Manager option instead.",
    "sd.platform.name.generic": "Any website",
    "sd.platform.name.wordpress": "WordPress",
    "sd.platform.name.shopify": "Shopify",
    "sd.platform.name.wix": "Wix",
    "sd.platform.name.squarespace": "Squarespace",
    "sd.platform.name.webflow": "Webflow",
    "sd.platform.name.gtm": "Google Tag Manager",
    "sd.install.generic.1": "Copy the snippet below.",
    "sd.install.generic.2": "Paste it into your site's <head> - or just before the closing </body> tag if that's easier.",
    "sd.install.generic.3": "Publish your site and reload any page - the chat bubble appears in the bottom-right corner, and the badge above flips to Synced.",
    "sd.install.wordpress.1": "In your WordPress admin, install a header-code plugin such as WPCode (free). Appearance → Theme File Editor works too, but a theme update would wipe the change.",
    "sd.install.wordpress.2": "Open the plugin's Header section - or Footer, if that's easier - and paste the snippet below.",
    "sd.install.wordpress.3": "Save, then reload your site - the chat bubble appears in the bottom-right corner.",
    "sd.install.shopify.1": "In your Shopify admin, go to Online Store → Themes → ⋯ → Edit code.",
    "sd.install.shopify.2": "Open layout/theme.liquid and paste the snippet below just before </head> - or just before </body>, if that's easier.",
    "sd.install.shopify.3": "Save - the chat bubble appears on your storefront.",
    "sd.install.wix.1": "In your Wix dashboard, go to Settings → Custom code (available on Premium plans with a connected domain).",
    "sd.install.wix.2": "Click “Add custom code”, paste the snippet below, apply it to All pages and load it in the Head - or in Body - end, if that's easier.",
    "sd.install.wix.3": "Save and publish - the chat bubble appears on your site.",
    "sd.install.squarespace.1": "In Squarespace, go to Settings → Advanced → Code Injection (available on the Business plan and higher).",
    "sd.install.squarespace.2": "Paste the snippet below into the Header field - or the Footer field, if that's easier.",
    "sd.install.squarespace.3": "Save - the chat bubble appears on your site.",
    "sd.install.webflow.1": "In Webflow, open Site settings → Custom code (available on paid site plans).",
    "sd.install.webflow.2": "Paste the snippet below into the Head code field - or the Footer code field, if that's easier.",
    "sd.install.webflow.3": "Save and publish - the chat bubble appears on your site.",
    "sd.install.gtm.1": "In Google Tag Manager, create a new Tag → Custom HTML and paste the snippet below.",
    "sd.install.gtm.2": "Set the trigger to All Pages (Page View).",
    "sd.install.gtm.3": "Submit and publish the container - the chat bubble appears on your site.",
    "sd.syncPending": "Auto-sync pending",
    "sd.synced": "Synced",
    "sd.copy": "Copy snippet",
    "sd.copied": "Copied ✓",
    // Firewall / WAF / CSP allowlist - some sites block requests to us by default
    "sd.fw.title": "Behind a firewall, WAF, or Content Security Policy?",
    "sd.fw.sub": "The chat widget and Neural Scan both talk to a single domain. Allow outbound requests to it so they aren't blocked.",
    "sd.fw.manualIntro": "Add these yourself, in your firewall/WAF and CSP configuration:",
    "sd.fw.allow": "Firewall or WAF - add this domain to your allow rule",
    "sd.fw.cspIntro": "Content Security Policy - add the domain above to these directives:",
    "sd.fw.script": "loads the widget, and the Agent configurator while you're editing it live on this site",
    "sd.fw.connect": "chat & Neural Scan requests",
    "sd.fw.img": "your widget logo, if you set one",
    "sd.fw.inbound": "No inbound access is needed - we never connect to your server. Everything runs in the browser and only reaches out to the domain above.",
    "sd.fw.aiIntro": "Or copy this prompt into whichever AI manages your infrastructure - it points the AI at your actual firewall/WAF and CSP config, and explains why each change is needed.",
    "sd.fw.promptLabel": "Prompt for your own AI",
    "sd.privacy.title": "Privacy policy adjustments and modifications",
    "sd.privacy.sub": "Your privacy policy is yours to maintain - this assistant reads pages and answers questions on your site, so it belongs in it.",
    "sd.privacy.manualIntro": "Copy this into your privacy policy as-is - it explains what the assistant does and why, in the language your visitors expect a privacy policy to use.",
    "sd.privacy.passageLabel": "Passage to add to your privacy policy",
    "sd.privacy.placementLabel": "Where it goes",
    "sd.privacy.aiIntro": "If an AI helps you draft or update your policy, paste this prompt into it instead of the passage above - it points the AI at your actual document, so the wording matches the rest of your policy.",
    "sd.privacy.promptLabel": "Prompt for your own AI",
    "sd.privacy.copy": "Copy",
    "sd.answersServed": "Answers served",
    "sd.settings": "Settings",
    "sd.save": "Save changes",
    "sd.saved": "Saved ✓",
    "sd.excluded": "Excluded URLs",
    "sd.excludedSub": "Pages where the assistant stays hidden and reads nothing - sign-in screens, admin areas, anything private.",
    "sd.excludedPh": "/account/*  or  #/login",
    "sd.excludedAdd": "Add",
    "sd.excludedHint": "Patterns match the page path: use * as a wildcard (/admin/*), start with # for hash-based routes (#/login), or paste a full URL. Takes effect on the next page load.",
    "sd.selExcluded": "Excluded content",
    "sd.selExcludedSub": "Parts of a page the assistant never reads or sends to the AI - private data, sensitive tables, personal messages.",
    "sd.selExcludedPh": ".sensitive-panel  or  #billing-table",
    "sd.selExcludedHint": "CSS selectors: each matching element and everything inside it is left out of the page snapshot. If you can edit your HTML, you can also add the data-aig-snapshot-exclude attribute to any element - no configuration needed. Takes effect on the next page load.",
    "sd.selExcludedEmpty": "No excluded content - the assistant can read the whole page (values typed into forms are never captured).",
    "sd.excludedEmpty": "No excluded URLs - the assistant appears on every page.",
    "sd.danger": "Danger zone",
    "sd.dangerSub": "Deleting a site removes its assistant, configuration and history. This cannot be undone.",
    "sd.delete": "Delete site",
    "sd.delTitle": "Delete this site?",
    "sd.delBody": "“{0}” and its assistant, configuration and history will be permanently removed. This cannot be undone.",
    "sd.delConfirm": "Delete permanently",
    // knowledge
    "kn.title": "What the assistant knows",
    "kn.empty": "The assistant doesn’t know this site yet. Open Agent to teach it your pages.",
    "kn.pages": "pages",
    "kn.topics": "Questions this page answers",
    // admin console
    "ac.title": "Admin console",
    "ac.sub": "Every client, their usage and your margin.",
    "ac.clients": "Clients",
    "ac.mrr": "Est. MRR",
    "ac.responses": "Answers this month",
    "ac.tokens": "Tokens this month",
    "ac.aicost": "AI cost this month",
    "ac.margin": "Est. gross margin",
    "ac.sites": "Sites",
    "ac.chartTitle": "AI cost by client - this month",
    "ac.chartEmpty": "No usage yet this month.",
    "ac.tableTitle": "Clients",
    "ac.col.client": "Client",
    "ac.col.plan": "Plan",
    "ac.col.scans": "Scans",
    "ac.col.answers": "Answers",
    "ac.col.cost": "AI cost",
    "ac.col.margin": "Margin",
    "ac.col.renewal": "Renews",
    "ac.siteOne": "site",
    "ac.siteMany": "sites",
    "ac.scansHint": "Neural Scan / manual page scan",
    "ac.costHint": "Setup cost (scan + onboarding) / message cost - all-time, covers total",
    "ac.addons": "Add-ons",
    "ac.addonsTitle": "Add-ons for {0}",
    "ac.addonsCurrent": "Current: {0} bonus messages · {1} extra sites",
    "ac.addonsMessages": "Add messages (one-time)",
    "ac.addonsSites": "Add sites",
    "ac.addonsApply": "Apply",
    "ac.addonsDone": "Add-ons updated.",
    "ac.extraSitesTag": "+{0} sites",
    "ac.extraSitesHint": "Extra site slots granted as an add-on, on top of the plan limit",
    "ac.bonusTag": "+{0} bonus",
    "ac.bonusHint": "Bonus answers granted as an add-on - a one-time pool served over the plan's monthly limit",
    "ac.addonsEmpty": "Enter a message or site amount, or change the granted plan.",
    "ac.grantPlan": "Grant plan (no billing change)",
    "ac.grantNone": "- no grant -",
    "ac.grantHint": "Opens this plan's features and limits on top of the paid plan ({0}). Nothing is charged, Stripe is untouched, and MRR is unaffected. To actually move the client to another plan, use the plan dropdown instead.",
    "ac.grantTag": "{0} granted",
    "ac.grantOverLimit": "Grant updated, but the account is now over its limits: {0} site(s) and {1} answer(s) beyond the plan. Nothing was deleted - review before leaving it this way.",
    "ac.planChanged": "Plan updated to {0}.",
    "plan.grantedBadge": "{0} enabled by our team",
    "plan.grantedCovered": "Included in your plan",
    "plan.grantedCoveredHint": "Our team enabled this plan on your account - there is nothing to pay. Contact us to change it.",
    "plan.answersLeft": "Answers left",
    "plan.portalNote": "Card, invoices and cancellation: use “Manage billing” above. Plan changes apply from these cards.",
    "plan.addonsNote": "Need more sites or answers than your plan includes? Upgrade above, or",
    "plan.addonsLink": "write to us",
    "plan.addonsNoteEnd": "and we'll add them to your account.",
    "plan.addonsMailSubject": "Extra answers or sites",
    "sites.liveLimit": "Your plan allows {0} live site(s), and you already have that many running. Turn another one off first, or upgrade - nothing was deleted, the site and everything you built stays.",
    "ac.renewalNever": "not started",
    "ac.renewalOk": "renewal is on track",
    "ac.renewalGrace": "{0} day(s) overdue - within the 5-day grace period",
    "ac.renewalOverdue": "{0} day(s) overdue - past the 5-day grace period",
    "ac.markPaid": "Mark paid",
    "ac.markPaidDone": "Payment recorded for {0} - renewal date advanced.",
    "ac.markPaidCharged": "Recorded €{0} for {1} - renewal date advanced.",
    "ac.discountHint": "Code {0}: charge €{1} instead of €{2} ({3}% off first payment)",
    "ac.you": "you",
    "ac.codePending": "pending",
    "ac.codeConsumed": "consumed",
    "ac.codeInactive": "inactive",
    "ac.trialBadge": "TRIAL",
    "ac.extendTrial": "Extend trial",
    "ac.extendTrialTitle": "Extend trial for {0}",
    "ac.extendTrialBody": "New trial end date (YYYY-MM-DD). The Stripe trial is moved to end of that day.",
    "ac.extendTrialLabel": "New trial end date",
    "ac.extendTrialBtn": "Extend trial",
    "ac.extendTrialBadDate": "Enter a valid date as YYYY-MM-DD.",
    "ac.extendTrialDone": "Trial for {0} now ends {1}.",
    "ac.impersonate": "Impersonate",
    // Admin impersonation banner (shown while an admin views a client's account)
    "imp.bannerPrefix": "You are viewing",
    "imp.bannerSuffix": "'s account as admin",
    "imp.exit": "Exit impersonation",
    // Content Hub (News / Research / Blog) - admin, etapa E2
    "content.sub": "Draft, review and publish. Nothing goes live without an admin's approval.",
    "content.editor": "Editor",
    "content.new": "New item",
    "content.empty": "No items yet. Create the first one.",
    "content.untitled": "Untitled",
    "content.col.title": "Title",
    "content.col.status": "Status",
    "content.col.seo": "SEO",
    "content.col.updated": "Updated",
    "content.status.draft": "Draft",
    "content.status.in_review": "In review",
    "content.status.scheduled": "Scheduled",
    "content.status.published": "Published",
    "content.status.archived": "Archived",
    "content.write": "Write",
    "content.preview": "Preview",
    "content.body.placeholder": "Write the article in Markdown…",
    "content.save": "Save",
    "content.saving": "Saving…",
    "content.saved": "Saved",
    "content.saveErr": "Couldn't save",
    "content.submit": "Submit for review",
    "content.reject": "Request changes",
    "content.approve": "Approve & publish",
    "content.archive": "Archive",
    "content.delete": "Delete",
    "content.delete.confirm": "Delete \"{0}\" permanently? This only works for drafts and can't be undone.",
    "content.archive.confirm": "Archive this item? It will be removed from the public site.",
    "content.viewPreview": "View the real page ↗",
    "content.slug.derive": "Derive from title",
    "content.f.title": "Title",
    "content.f.slug": "Slug",
    "content.f.dek": "Standfirst (dek)",
    "content.f.meta": "Meta description",
    "content.f.excerpt": "Excerpt",
    "content.f.author": "Author",
    "content.f.tags": "Tags",
    "content.f.hero": "Hero image URL",
    "content.f.heroAlt": "Hero alt text",
    "content.tag.placeholder": "Add a tag, press Enter",
    "content.tag.remove": "Remove tag",
    "content.seo.title": "SEO checks",
    "content.seo.meta": "Meta description length",
    "content.seo.slug": "Slug",
    "content.seo.hero": "Hero image",
    "content.seo.thin": "Content length",
    "content.seo.tooShort": "a bit short",
    "content.seo.metaHint": "Meta description is 120–160 characters",
    "content.seo.slugHint": "Slug is lowercase words separated by hyphens",
    "content.seo.heroHint": "A hero image is set (link previews look plain without one)",
    "content.seo.thinHint": "Enough words for this section to rank",
    "content.ai.title": "Generate with AI",
    "content.ai.subGenerate": "One brief in, a full draft out: title, slug, dek, meta description, excerpt, body, tags and a hero image. Review everything below, then save.",
    "content.ai.subRevise": "Tell the AI what to change - it rewrites the draft, and every version is kept.",
    "content.ai.briefPlaceholder": "What should this article be about? (optional - leave empty to let AI choose an angle)",
    "content.ai.revisePlaceholder": "e.g. shorter intro, add a section about pricing, less salesy…",
    "content.ai.generate": "Generate full article",
    "content.ai.revise": "Revise article",
    "content.ai.working": "Working",
    "content.ai.wait": "Takes 10–40s. The draft updates only when it's ready.",
    "content.ai.waitGenerate": "Takes 15–60s - the article and its hero image both need to finish.",
    "content.ai.failed": "The AI request failed - your draft is untouched.",
    "content.ai.filled": "Filled",
    "content.ai.collapsedFrom": "Generated from",
    "content.ai.collapsedEmpty": "(no brief given)",
    "content.ai.reopenHint": "Reopen to revise",
    "content.ai.fieldBadge": "AI",
    "content.hero.title": "Hero image",
    "content.hero.subGenerated": "Generated with the article.",
    "content.hero.subEmpty": "Generate the article above, or create an image on its own.",
    "content.hero.ready": "Ready",
    "content.hero.painting": "Painting",
    "content.hero.failedBadge": "Failed",
    "content.hero.failed": "Image generation failed - the rest of the article is unaffected. Try again.",
    "content.hero.generate": "Generate image",
    "content.hero.regenerate": "Regenerate",
    "content.hero.editPrompt": "Edit prompt",
    "content.hero.applyPrompt": "Generate with this prompt",
    "content.hero.cancelEdit": "Cancel",
    "content.hero.promptPlaceholder": "Describe the hero image…",
    "content.hero.unsavedNote": "Save the draft first to generate a hero image.",
    "content.unsavedNote": "Save the draft to unlock distribution and revision history.",
    "content.dist.title": "Share to social",
    "content.dist.sub": "Auto-post when this article publishes. Copy is per channel.",
    "content.dist.add": "Add channel",
    "content.dist.channel": "Channel",
    "content.dist.soon": "coming soon",
    "content.dist.when": "When",
    "content.dist.mode.publish": "When the article publishes",
    "content.dist.mode.offset": "Some time after publishing",
    "content.dist.mode.at": "At a specific time",
    "content.dist.minutesAfter": "minutes after publishing",
    "content.dist.copy": "Post copy",
    "content.dist.copyPlaceholder": "What to post on this channel…",
    "content.dist.save": "Add",
    "content.dist.empty": "No channels yet.",
    "content.dist.badTime": "Enter a valid date and time.",
    "content.dist.due": "Goes out",
    "content.dist.sentAt": "Sent",
    "content.dist.afterPublish": "Goes out after the article publishes",
    "content.dist.cancel": "Cancel",
    "content.dist.draftNote": "These go out only once the article is published.",
    "content.dist.status.pending": "Scheduled",
    "content.dist.status.sent": "Sent",
    "content.dist.status.failed": "Failed",
    "content.dist.status.cancelled": "Cancelled",
    "content.rev.title": "Revisions",
    "content.rev.save": "Save checkpoint",
    "content.rev.empty": "No revisions yet.",
    "content.rev.ai": "AI",
    "content.rev.admin": "Admin",
    "content.reschedule": "Reschedule",
    "content.publishNow": "Publish now",
    "content.sched.title": "Approve & schedule",
    "content.sched.retitle": "Reschedule",
    "content.sched.body": "Publish now, or pick a date and time. Times are in Tenerife (Atlantic/Canary).",
    "content.sched.at": "Publish date & time",
    "content.sched.now": "Publish now",
    "content.sched.schedule": "Schedule",
    "content.sched.for": "Scheduled for",
    "content.sched.invalid": "Enter a valid date and time.",
    "content.sched.past": "That time is in the past - pick a future time, or publish now.",
    "content.msg.scheduled": "Scheduled.",
    "content.msg.submitted": "Submitted for review.",
    "content.msg.rejected": "Sent back to draft.",
    "content.msg.published": "Published.",
    "content.msg.archived": "Archived.",
    "content.err.slugTaken": "That slug is already used by another item in this section.",
    "content.err.notReviewed": "This item hasn't been approved yet.",
    // codes & referrals (admin console)
    "cd.title": "Codes & referrals",
    "cd.sub": "Promo campaigns, partner codes, and the commissions you owe.",
    "cd.newTitle": "New code",
    "cd.code": "Code",
    "cd.type": "Type",
    "cd.type.promo": "Promo (campaign)",
    "cd.type.partner": "Partner (earns commission)",
    "cd.benefit": "Benefit",
    "cd.benefit.percent": "% off first payment",
    "cd.benefit.credit": "€ credit",
    "cd.benefit.trialDays": "trial days",
    // variantele scurte pentru tabel, unde valoarea își poartă deja unitatea
    "cd.short.percent_first_payment": "off first payment",
    "cd.short.credit_eur": "credit",
    "cd.short.trial_days": "trial days",
    "cd.value": "Value",
    "cd.commission": "Commission %",
    "cd.owner": "Owner account ID",
    "cd.ownerHint": "Required for partner codes and any commission.",
    "cd.maxUses": "Max uses",
    "cd.maxUsesHint": "Leave empty for unlimited.",
    "cd.expires": "Expires",
    "cd.create": "Create code",
    "cd.created": "Code {0} created.",
    "cd.codesTitle": "Codes",
    "cd.codesEmpty": "No codes yet. Referral codes are created by clients themselves and show up here once used.",
    "cd.col.uses": "Uses",
    "cd.col.owner": "Owner",
    "cd.col.status": "Status",
    "cd.active": "Active",
    "cd.inactive": "Inactive",
    "cd.deactivate": "Deactivate",
    "cd.deactivated": "Code {0} deactivated.",
    "cd.earningsTitle": "Commissions owed",
    "cd.earningsEmpty": "No commissions yet.",
    "cd.col.referrer": "Referrer",
    "cd.col.referred": "Referred account",
    "cd.col.amount": "Amount",
    "cd.col.available": "Available on",
    "cd.cancel": "Cancel",
    "cd.cancelTitle": "Cancel this commission?",
    "cd.cancelBody": "Commission earned on code {0}. The reason is recorded in the audit trail.",
    "cd.cancelPrompt": "Reason (e.g. refund)",
    "cd.cancelPlaceholder": "Customer refunded on 12 Jul",
    "cd.cancelBtn": "Cancel commission",
    "cd.cancelForce": "This commission is already out of its hold window - the money was promised to the referrer.",
    "cd.cancelled": "Commission cancelled.",
    "cd.unlimited": "unlimited",
    "tk.title": "Support tickets",
    "tk.sub": "Emails received on support@ - reply directly from here.",
    "tk.col.num": "#",
    "tk.col.from": "From",
    "tk.col.subject": "Subject",
    "tk.col.status": "Status",
    "tk.col.last": "Last activity",
    "tk.col.duration": "Open for",
    "tk.status.open": "Open",
    "tk.status.pending": "Pending",
    "tk.status.closed": "Closed",
    "tk.ticketNo": "Ticket #{0}",
    "tk.filterFrom": "From",
    "tk.filterTo": "To",
    "tk.filterToPlaceholder": "Now",
    "tk.filterClear": "Reset",
    "tk.empty": "No tickets yet.",
    "tk.emptyFiltered": "No tickets match these filters.",
    "tk.replyPlaceholder": "Write a reply…",
    "tk.send": "Send reply",
    // shared
    "err.generic": "Error",
    "err.network": "Network error. Please try again.",
    // Billing errors - one line per code emitted by services/stripeBilling.ts.
    // These are read by a customer mid-purchase, so they say what happened and
    // what to do next; the machine code stays in the console.
    "errb.generic": "Something went wrong on our side. Please try again, or contact support if it keeps happening.",
    "errb.billing_not_configured": "Payments are temporarily unavailable. We're on it - please try again shortly.",
    "errb.stripe_error": "Our payment provider couldn't complete this right now. No charge was made. Please try again in a moment.",
    "errb.already_subscribed": "You already have an active subscription. Use “Manage billing” to change it.",
    "errb.no_stripe_customer": "We couldn't find your billing profile. Please contact support so we can reconnect it.",
    "errb.no_subscription": "You don't have an active subscription yet. Pick a plan first.",
    "errb.same_plan": "You're already on this plan.",
    "errb.same_quantity": "That's already your current number of site slots.",
    "errb.not_activated": "Extra answers need an active plan. Choose a plan first, then top up.",
    "errb.sites_in_use": "You're using {0} site slots right now. Delete a site first, then reduce the slots.",
    "errb.sites_in_use_generic": "Some of those slots are in use by existing sites. Delete a site first, then reduce the slots.",
    "errb.invalid_request": "We couldn't process that request. Please refresh the page and try again.",
    "errb.not_cancelling": "Your subscription isn't set to end, so there is nothing to resume.",
    "errb.subscription_ending": "Your subscription ends at the end of this period. Resume it first, then change your plan.",
    "errb.plan_granted": "This plan is already enabled on your account by our team - there is nothing to pay. Contact us if you'd like to change it.",
    "common.cancel": "Cancel",
    "common.close": "Close",
    "common.loading": "Loading…",
    "common.save": "Save",
  },
} as const;

export type Lang = keyof typeof STRINGS;
export type StringKey = keyof (typeof STRINGS)["en"];

/**
 * Momentan doar engleză. Când adaugi limbi, reintrodu aici selecția
 * (localStorage "aig_lang" / navigator.language) și un setLang() persistent.
 */
export function getLang(): Lang {
  return "en";
}

export function t(key: StringKey, ...args: (string | number)[]): string {
  let text: string = STRINGS[getLang()][key] ?? STRINGS.en[key] ?? key;
  args.forEach((arg, i) => {
    text = text.replace(`{${i}}`, String(arg));
  });
  return text;
}

/** Ca t(), dar fără interpolare - păstrează markerii {0}, {1}... pentru highlight-ul cifrelor. */
export function tRaw(key: StringKey): string {
  return STRINGS[getLang()][key] ?? STRINGS.en[key] ?? key;
}
